module.exports = __webpack_public_path__ + "img/vg.42ec4c56.jpg";